export function isDefined<T>(foo?: T | null): foo is T {
  return foo !== undefined && foo !== null;
}
